'use client'
import { createContext, useContext, useEffect, useState } from 'react'
import { apiUrl } from '../runtime'

// Widget replacement for `@/lib/crownContext`. Same shape, but fetches the public crown state
// from core's CORS-enabled backend. A relative URL would hit the embedding app, while core's
// Next.js `/api/crown` proxy does not provide cross-origin response headers.
const CrownContext = createContext<string | null>(null)

export function CrownProvider({ children }: { children: React.ReactNode }) {
  const [holder, setHolder] = useState<string | null>(null)

  useEffect(() => {
    fetch(apiUrl('/api/items/cheese-crown'), { credentials: 'include' })
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (data) setHolder(data.holder_discord_username ?? data.holder_username ?? null)
      })
      .catch(() => {})
  }, [])

  return <CrownContext.Provider value={holder}>{children}</CrownContext.Provider>
}

export function useCrown(): string | null {
  return useContext(CrownContext)
}
